import { AfterViewInit, Component, HostListener } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ChangePasswordDialogComponent } from '@components/change-password-dialog/change-password-dialog.component';
import { RegulationDialogComponent } from '@components/regulation-dialog/regulation-dialog.component';
import { LoginDto } from '@models/users/login.dto';
import { AccountService } from '@services/account.service';
import { RegulationService } from '@services/regulation.service';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'ebs-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements AfterViewInit {
  showForgotten: boolean = false;
  showFirstAccess: boolean = false;

  formGroup!: FormGroup;

  public loginDto: LoginDto = {
    password: '',
    email: '',
  };

  constructor(
    private router: Router,
    public dialogService: DialogService,
    private regulationService: RegulationService,
    private accountService: AccountService,
  ) {
    this.formGroup = new FormGroup({
      email: new FormControl<string>('', [
        Validators.required,
        Validators.email,
      ]),
      password: new FormControl<string>('', [
        Validators.required,
        Validators.minLength(8),
        Validators.pattern(
          /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[?%&!@#$%^&*_=().:,;£+|\\\/\-]).{8,32}$/,
        ),
      ]),
    });
    if (accountService.isLoggedIn) {
      router.navigateByUrl('/home');
    }
  }
  ngAfterViewInit(): void {
    if (this.accountService.isLoggedIn) {
      this.router.navigateByUrl('/home');
    }
  }

  @HostListener('window:keydown.enter', ['$event'])
  onKeyPress(evt) {
    if (evt.key === 'Enter' && this.formGroup.valid) {
      this.loginClick();
    }
  }

  loginClick() {
    this.accountService.login(this.loginDto).subscribe((result) => {
      this.accountService.getUserInfo().subscribe((result) => {
        if (result.mustChangePassword) {
          let dialogRef: DynamicDialogRef = this.dialogService.open(
            ChangePasswordDialogComponent,
            {
              maximizable: false,
              draggable: false,
              closable: false,
              closeOnEscape: false,
              header: 'Password scaduta',
            },
          );

          dialogRef.onClose.subscribe((result) => {
            if (!result) {
              return;
            }
            this.accountService.changePassword(result).subscribe();
          });
        }
        if (result.emptyRegulations.length > 0) {
          let dialogRef: DynamicDialogRef = this.dialogService.open(
            RegulationDialogComponent,
            {
              maximizable: false,
              draggable: false,
              closable: false,
              closeOnEscape: false,
              header: 'Consensi',
              data: {
                regulations: result.emptyRegulations,
              },
            },
          );

          dialogRef.onClose.subscribe((result) => {
            if (!result) {
              return;
            }
            this.regulationService.acceptRegulation(result).subscribe();
          });
        }
        this.router.navigateByUrl('/home');
      });
    });
  }
}
